import { svgSprite, Tooltip } from '../../../../../../hybrid/wrappers';
import FromInputTitle from '../../../FormFieldTitle/FormFieldTitle';
import { getInputStyles, useWidthOfInputWrapper } from '../../helpers';
import CopyType from '../CopyType/CopyType';
import ModalSeachType from '../ModalSeachType/ModalSeachType';
import PasswordType from '../PasswordType/PasswordType';
import css from './Elements.module.scss';
import classnames from 'classnames';
import Addon from '../Addon/Addon';
import { generateCompStylers } from '../../../../../../common/utils/styles';
import { getIsCoupleVariation } from '../../../helpers';
import { UserProfileContext } from '../../../../../../common/utils/getContext';
import { useRef, useEffect, useState, useContext } from 'react';
import FromControl from '../../../FromControl/FromControl';
import PhoneButton from '../Phone/PhoneButton/PhoneButton';
import BinarySettings from '../BinarySettings/BinarySettings';

const InputSwitcher = (props) => {
    const { adminPage } = useContext(UserProfileContext) || {};
    const {
        hint,
        placeholder,
        required,
        readonly,
        disabled,
        title,
        compStyle = {},
        type = 'input',
        errors,
        message,
        search,
        addon,
        addonLast,
        copy,
        tooltip,
        customData = {},
        buttons = {},
        placeholderError,
        keyword,
        changeHandler,
        variationStyle,
        val,
        focused,
        componentConfig,
        setShowPass,
        showPass,
        minInputWidth,
        placeholderHidden = true,
        inputRef,
        selectedCountry,
        phoneDropDown
    } = props;
    const { stylers, classes } = generateCompStylers(compStyle);
    const [isFilled, setIsFilled] = useState(Boolean(val));

    useEffect(() => {
        setIsFilled(Boolean(val));
    }, [val]);

    const styleConfig = {
        style: getInputStyles(stylers, errors, focused, disabled, minInputWidth),
        className: adminPage ? css.inputAdmin : css.input
    };
    const inputWrapperRef = useRef();
    const wrapperWidth = useWidthOfInputWrapper(minInputWidth, inputWrapperRef);

    switch (keyword) {
        case 'search':
            return search && search?.type === 'modal' ? (
                <ModalSeachType search={search} changeHandler={changeHandler} />
            ) : search ? (
                <div
                    onClick={search?.onClick}
                    style={stylers.search}
                    className={classnames(css.formControlIconWrap, classes.search)}
                >
                    {svgSprite(search?.icon || 'search-gt', {
                        style: stylers.icon,
                        className: classnames(css.formControlSearchIconSvg, classes.icon)
                    })}
                </div>
            ) : null;
        case 'input':
            return (
                <div
                    ref={inputWrapperRef}
                    style={{ ...wrapperWidth, ...stylers.inner, ...(adminPage ? { 'margin-left': '0px' } : {}) }}
                    className={classnames(css.formControlInner, classes.inner)}
                >
                    {!!title && getIsCoupleVariation(variationStyle) ? (
                        <FromInputTitle
                            id={componentConfig?.id}
                            errors={errors}
                            title={title}
                            compStyle={compStyle}
                            hint={hint}
                            required={required}
                            isFilled={isFilled}
                            variationStyle={variationStyle}
                            focused={focused}
                            type={type}
                        />
                    ) : null}
                    <Tooltip
                        text={tooltip}
                        compStyle={{
                            inner: classnames(
                                css.formControlContentAddon,
                                addon ? css.formControlContentAddonScroll : {},
                                !isFilled && !focused && type !== 'phone-widget' && placeholderHidden ? css.formHiddenInput : {},
                                classes.formControlContentAddon
                            ),
                            ...(type === 'phone-widget' ? { tooltipWrapCustom: { position: 'static' } } : {})
                        }}
                    >
                        {!!customData?.isSocial ? (
                            <div className={classnames(css.formControlIconWrap, css.formControlIconSotialWrap)}>
                                {svgSprite('at', {
                                    className: classnames(css.formControlSocialIconSvg, classes.label),
                                    style: {
                                        ...stylers.social,
                                        fill:
                                            errors && errors.length
                                                ? 'var(--goldColor)'
                                                : focused
                                                ? 'var(--neutral500)'
                                                : 'var(--goldColor)'
                                    }
                                })}
                            </div>
                        ) : null}
                        {!!addon ? <Addon addon={addon} compStyle={compStyle} /> : null}
                        {type === 'phone-widget' ? (
                            <>
                                <PhoneButton
                                    disabled={disabled}
                                    compStyle={compStyle}
                                    selectedCountryData={selectedCountry}
                                    phoneDropDown={phoneDropDown}
                                />
                                <div
                                    className={classnames(styleConfig.className, css.phone_code)}
                                    style={{ ...styleConfig.style }}
                                >
                                    {selectedCountry?.phone_code}
                                </div>
                            </>
                        ) : null}
                        {/* {type === 'phone-widget' ? (
                            <div className={css.input} style={getInputStyles(stylers, errors, focused, disabled)}>
                                <PhoneInput {...componentConfig} {...styleConfig} />
                            </div>
                        ) : (
                            <FromControl
                                {...{
                                    placeholder,
                                    placeholderError,
                                    compStyle,
                                    title,
                                    errors,
                                    required,
                                    val,
                                    focused,
                                    disabled,
                                    readonly
                                }}
                            >
                                <input {...componentConfig} {...styleConfig} ref={inputRef} />
                            </FromControl>
                        )} */}
                        {
                            <FromControl
                                {...{
                                    placeholder,
                                    placeholderError,
                                    compStyle,
                                    title,
                                    errors,
                                    required,
                                    val,
                                    focused,
                                    disabled,
                                    readonly
                                }}
                            >
                                <input {...componentConfig} {...styleConfig} ref={inputRef} />
                            </FromControl>
                        }
                        {!!addonLast ? <Addon addon={addonLast} isLast={true} compStyle={compStyle} /> : null}
                    </Tooltip>
                </div>
            );
        case 'password':
            return type === 'password' ? (
                <PasswordType setShowPass={setShowPass} showPass={showPass} compStyle={compStyle} />
            ) : null;
        case 'copy':
            return copy ? <CopyType copy={copy} message={message} val={val} compStyle={compStyle} /> : null;
        case 'binar_settings':
            return <BinarySettings />;
        default:
            if (buttons[keyword]) {
                const { stylersBtn, classesBtn } = generateCompStylers(compStyle?.[keyword], 'Btn');

                const btn = buttons[keyword];
                return (
                    <div onClick={btn.handler}>
                        <Tooltip
                            text={btn.hint}
                            compStyle={{
                                inner: {
                                    className: classnames(css.formControlIconWrap, css.hoverBtn, classesBtn.button),
                                    ...stylersBtn.button
                                }
                            }}
                        >
                            {btn.icon
                                ? svgSprite(btn.icon, {
                                      width: '20px',
                                      height: '20px',
                                      fill: 'var(--greyExtraDarkColor)',
                                      className: classnames(css.iconSvg, classesBtn.icon),
                                      ...stylersBtn.icon
                                  })
                                : btn.name}
                        </Tooltip>
                    </div>
                );
            }
            return null;
    }
};
export default InputSwitcher;
